module.exports = __webpack_public_path__ + "static/img/log2.183cfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moneyStage/log2.png
// module id = +1M0
// module chunks = 44